export const valueMap = (values: object) => {
  const included: Array<string> = [];

  Object.entries(values).forEach(([value, include]) => {
    if (include) included.push(value);
  });

  return included.join(' ');
};
